import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';

import { DialogAppTitle, DialogAppContent, DialogAppActions } from 'components/DialogApp';
import ButtonLoader from 'components/common/ButtonLoader';

const titleText = usersCount => {
  if (!usersCount) return 'No selected users';
  if (usersCount === 1) return 'Remove tag from selected person';
  return `Remove tag from these ${usersCount} users`;
};

const tagButtonText = usersCount => {
  if (!usersCount) return null;
  if (usersCount === 1) return 'Remove tag from person';
  return `Remove tag from these ${usersCount} users`;
};

const styles = {
  select: {
    width: '100%',
  },
};

const Layout = ({
  classes,
  selectedUsers,
  tagToRemove,
  onChange,
  tags,
  toggleDialog,
  handleRemoveUsersTags,
  disableActionButton,
}) => {
  const usersCount = selectedUsers.length;
  const areUsersSelected = !!usersCount;

  return (
    <React.Fragment>
      <DialogAppTitle small>
        {titleText(usersCount)}
      </DialogAppTitle>

      <DialogAppContent>
        {!areUsersSelected && <div>Select at least one user to be able to add a tag.</div>}

        {areUsersSelected && (
          <div>
            <Select
              value={tagToRemove}
              onChange={onChange}
              className={classes.select}
              inputProps={{
                name: 'tagToRemove',
              }}
              autoWidth
            >
              <MenuItem value={0}>Select Tag You want to remove</MenuItem>
              {tags.map(tag => <MenuItem key={tag.id} value={tag.name}>{tag.name}</MenuItem>)}
            </Select>
          </div>
        )}
      </DialogAppContent>

      <DialogAppActions>
        <Button onClick={toggleDialog} color="primary">
          Cancel
        </Button>

        {areUsersSelected && (
          <Button
            onClick={handleRemoveUsersTags}
            color="primary"
            disabled={!tagToRemove || disableActionButton}
          >
            {tagButtonText(usersCount)}
            {disableActionButton && <ButtonLoader />}
          </Button>
        )}
      </DialogAppActions>
    </React.Fragment>
  );
};

export default withStyles(styles)(Layout);



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/RemoveUsersTags/Layout.jsx